module.exports = __webpack_public_path__ + "img/not-authorized.dacf00d6.svg";